var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "root" }, [
    _c("p", [
      _vm._v("Escreva aqui as instruções e cuidados para a sua limpeza.")
    ]),
    _vm._v(" "),
    _c("textarea", {
      ref: "description",
      staticClass: "description",
      class: { "has-error": _vm.description.length === 980, pulse: _vm.focus },
      attrs: {
        placeholder:
          'Por exemplo: "Concentrar a limpeza no banheiro (principalmente no box e mofo das paredes) e cozinha. Utilizar o tempo restante para os quartos e sala." ou "Limpeza dos pisos do escritório e retirada de pó. Por favor, afaste os móveis para limpar embaixo..."',
        name: "description",
        rows: "5",
        maxlength: "980"
      },
      domProps: { value: _vm.description },
      on: {
        input: _vm.updateDescription,
        focus: function($event) {
          _vm.focus = true
        },
        blur: function($event) {
          _vm.focus = false
        }
      }
    }),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "alert" }, [
      _c("b", [_vm._v("Importante")]),
      _vm._v(": o profissional "),
      _c("b", [
        _vm._v(
          "não levará balde, vassoura, rodo, escada ou demais ferramentas ou EPI's"
        )
      ]),
      _vm._v(
        ". Se esses itens forem necessários, devem estar disponíveis no local da limpeza."
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-242b33dd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-242b33dd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/Components/Scheduler/Steps/AdditionalInformation/Description.vue
// module id = null
// module chunks = 